import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import LogoutButton from './components/LogoutButton/LogoutButton';
import logo from "./assets/logo.svg";


function Header() {
    const [activeItem, setActiveItem] = useState('/'); // Default active item is "/"

    // A helper function to determine if an item is active
    const isActive = (path) => activeItem === path ? 'bg-gray-900 text-white' : 'text-gray-300 hover:bg-gray-700 hover:text-white';

    return (
        <header className="bg-gray-800 text-white body-font shadow w-full">
            <div className="max-w-screen-md mx-auto flex flex-wrap p-5 flex-col md:flex-row items-center justify-between">
                <nav className="flex flex-wrap items-center text-base justify-center hidden md:flex">
                    <Link to="/" 
                        className={`flex title-font font-medium items-center text-white mb-4 md:mb-0`} 
                        onClick={() => setActiveItem('/')}>
                        <img src={logo} alt="Logo" className='w-10 h-10' />
                        <span className="ml-3 text-2xl font-semibold">Admin panel</span>
                    </Link>
                </nav>
                <Link 
                    to="/login" 
                    className={`text-base font-semibold mr-5 rounded-md px-3 py-2 ${isActive('/login')}`} 
                    >
                    <LogoutButton />
                </Link>

            </div>
        </header>
    );
}

export default Header;
